export default "__VITE_ASSET__096c8327__"